<script setup>
  import PagesRecordResultListChecks from "@pages/Records/Components/Result/ResultList/ListChecks.vue";

  defineOptions({
    name: "PagesRecordResultPrognosticResults",
  });

  defineProps({
    patientId: {
      type: String,
      required: true,
    },
    recordId: {
      type: String,
      required: true,
    },
    prognosticRedlights: {
      type: Array,
      default: () => {
        return [];
      },
    },
  });

  defineEmits(["open:shareDialog"]);
</script>

<template>
  <section v-if="prognosticRedlights.length > 0">
    <h2 class="border-b-1 border-gray-200 pb-6 text-center text-2xl font-semibold print:font-normal">
      Potentielle Risiken
      <span class="font-light">(Prognose)</span>
    </h2>

    <div class="mt-8 space-y-4 print:break-before-avoid-page">
      <h3 class="text-xl font-semibold">Weitere ABP (arzneimittelbezogene Probleme)</h3>

      <PagesRecordResultListChecks
        class="print:break-before-avoid-page"
        anchor-prefix="prognostic"
        :patient-id="patientId"
        :record-id="recordId"
        :checks="prognosticRedlights"
        :test-id="getTestId('prognostic')"
        @open:share-dialog="$emit('open:shareDialog')"
      />
    </div>
  </section>
</template>
